/**
 * Wartość dla `<input type="datetime-local">` jako LOKALNY zegar ścienny.
 *
 * NIE wolno tu ciąć surowego ISO/UTC (`.slice(0, 16)`) — pole datetime-local oczekuje
 * czasu lokalnego, więc UTC pokazywałby godzinę o offset strefy mniej (latem w PL: −2 h).
 * To był realny błąd: użytkownik wpisywał X, a pole po przeładowaniu pokazywało X−2.
 *
 * Przyjmuje ISO string albo Date; puste/nieprawidłowe → "".
 */
export function toDatetimeLocalValue(
  value: string | Date | null | undefined,
): string {
  if (!value) return "";
  const d = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(d.getTime())) return "";
  const pad = (n: number) => String(n).padStart(2, "0");
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(
    d.getHours(),
  )}:${pad(d.getMinutes())}`;
}
